export enum CompanyCompanyDataBlock {
  Root = 'CompanyCompanyData',
}

export enum CompanyCompanyDataElement {
  Link = 'link',
}
